import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../../firebase';
import user from '../../Auth/user';
import compose from '../../compose';
import AssChart from '../../Dashboard/AssChart';
import {SumBy, SumByMultiple} from '../../Dashboard/Functions';
import DateFilter from '../../Dashboard/DateFilter';

class Payment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previousFilter: null,
      currentFilter: null,
      filters: [],
      data: [],
      filteredData: null,
      display: 'block'
    };

  }

  fetchOrders = (startDate, endDate) => {
    const {firebase} = this.props;
    firebase
      .database()
      .ref('orders')
      .orderByChild('registeredDate')
      .startAt(startDate.getTime())
      .endAt(endDate.getTime())
      .once('value', (ordersSnapshot) => {
        const allOrders = [];
        ordersSnapshot.forEach((data) => {
          const order = {
            key: data.key,
            ...data.val()
          };
          if (!order.paymentAgreement) {
            allOrders.push(this.enhanceOrder(order));
          }
        });
        this.setState({data: allOrders, filteredData: allOrders});
      });
  }

  enhanceOrder = (order) => {
    const registeredDate = new Date(order.registeredDate);
    order.hour = '' + registeredDate.getHours();
    order.registeredAtDate = registeredDate;
    order.registeredAtDate.setHours(0,0,0,0);

    if (order.status === undefined) {
      order.status = 'CANCEL';
    }

    order.count = 1;
    order.weekday = order.registeredAtDate.toLocaleString(this.props.user.language, {weekday: 'long'});
    order.dayOfWeek = +order.registeredAtDate.getDay();
    order.registeredAtDateFormated = order.registeredAtDate.toLocaleDateString(this.props.user.language);
    return order;
  }

  onNewFilter = (key, value) => {
    const filters = this.state.filters;
    filters[key] = value;
    this.setState({filters});
  }

  cancelFilter = (key) => {
    const filters = this.state.filters;
    delete filters[key];
    this.setState({filters});
  }

  onFilterChange = (filter) => {
    const filteredData = this.state.data.filter(filter);
    this.setState({filteredData});
  }

  onEnlargeToggled = () => {
    // Forces redraw but flashes the screen
    this.setState({display: 'none'});
    setTimeout(() => this.setState({display: 'block'}), 1);
  }

  render() {

    const boxProps = {
      style: this.props.boxStyle,
      data: this.state.filteredData,
      filters: this.state.filters,
      cancelFilter: this.cancelFilter,
      onNewFilter: this.onNewFilter,
      onEnlargeToggled: this.onEnlargeToggled
    };

    const {t} = this.props;

    return (
      <div style={{display: this.state.display}}>
        <DateFilter updateFunction={this.fetchOrders}/>
        <div style={{clear: 'both'}}></div>
        <div style={{
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'space-between',
        }}>

          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.adminPayment.status')}
            aggregate={new SumBy('status', 'count')} />

          <AssChart {...boxProps}
            chartType='LineChart'
            title={t('dashboard.adminPayment.statusByDay')}
            isStacked={true}
            aggregate={new SumByMultiple(['registeredAtDateFormated', 'status'], 'count')} />

        </div>
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Payment);



// WEBPACK FOOTER //
// ./src/Admin/Dashboard/Payment.js